export default "__VITE_ASSET__b14ddaa0__"